import { Observable } from 'rxjs';

export interface ICanUploadFn {
  canUpload: boolean;
  errorMessage?: string;
}

export type CanUploadFn = (file: File) => Observable<ICanUploadFn>;
